export { default as FlokkarProductBanner } from "./flokkar-product-banner";



// WEBPACK FOOTER //
// ./src/components/Product-page/flokkar-product-banner/index.ts